import Mascot from '@maxpreps/shared/corecomponents/Image/Mascot';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import React from 'react';

const ScheduleMascot: React.FC<{
  contest: any /* TODO: True type */;
  size?: number;
}> = ({ contest, size }) => {
  const { color1, mascotUrl, name, isTeamTBA } = contest.opponentTeam;
  const isMobile = useIsMobile();

  return isTeamTBA ? null : (
    <Mascot
      backgroundColor={`#${color1}`}
      src={mascotUrl}
      size={size || (isMobile ? 32 : 40)}
      name={name}
    />
  );
};

export default ScheduleMascot;
